module.exports = __webpack_public_path__ + "arrow_blue_right.a441f213.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/arrow_blue_right.svg
 ** module id = 959
 ** module chunks = 0
 **/